import React from 'react'

function MainCertificate() {
    return (
        <div>
            
        </div>
    )
}

export default MainCertificate
